import { createAction, props } from '@ngrx/store';

export const loadAnnotations = createAction('[Annotations] Load Annotations');

export const loadAnnotationsSuccess = createAction(
  '[Annotations] Load Annotations Success',
  props<{ annotations: { [category: string]: { [id: string]: any } } }>()
);

export const loadAnnotationsFailure = createAction(
  '[Annotations] Load Annotations Failure',
  props<{ error: any }>()
);
